
import * as JSZIP from 'jszip';
import { ImageCanvasData } from '../Views/AtlasPacker/Observer';
import createAtlasJSON from './createAtlasJSON';

const createExportZipAtlas = (data: ImageCanvasData) => {
    const atlas_original = createAtlasJSON(1);
    const atlas_scaled = createAtlasJSON(data.scale);

    const JSZip = require('jszip');
    
    const zip: JSZIP = new JSZip();
    
    zip.file(`${data.name}.png`, data.src.replace('data:image/png;base64,', ''), { base64: true });
    zip.file(`${data.name}_atlas.json`, atlas_scaled);

    const folder_original = zip.folder('original');
    folder_original.file(`${data.name}.png`, data.src_original.replace('data:image/png;base64,', ''), { base64: true })
    folder_original.file(`${data.name}_atlas.json`, atlas_original);
    return zip;
}

export default createExportZipAtlas;